import React from "react";
import PaymentMethod from "home/components/payment-method";
import { currencyFormat } from "shared/components/helpers";

function PaymentStepThree(props) {
  return (
    <div>
      <h4>Confirm Payment Details</h4>
      <div className="confirm-lines">
        <div>Payment to: {props.currentPlan.provider}</div>
        <div>Amount: {currencyFormat(props.selectedAmount.value)}</div>
        <div>
          <span>Payment will be made using:</span>
          <PaymentMethod
            paymentMethod={props.selectedPaymentMethod}
            handleShow={props.handleShow}
            viewState={{
              showActions: false,
              showSelect: false,
              className: "col-md-6"
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default PaymentStepThree;



// WEBPACK FOOTER //
// ./src/home/components/payment-step-three.js